import { render, staticRenderFns } from "./Tripwepay.vue?vue&type=template&id=e81c4bb8&"
import script from "./Tripwepay.vue?vue&type=script&lang=js&"
export * from "./Tripwepay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports